<template>
	<div
		class="base_card"
		:class="`base_card__${type} base_card__${size} ${customClass}`"
	>
		<div
			class="base_card__header"
			:class="headerBorder ? 'border-bottom' : ''"
		>
			<slot v-if="$slots.title" name="title"></slot>
			<div v-else class="base_card__header_title">
				<van-image
					class="mr-20"
					v-if="getTitleIcon"
					:width="titleIconWidth"
					fit="contain"
					:src="getTitleIcon"
					:alt="title"
					:title="title"
				/>
				<span class="title_text">{{ title }}</span>
			</div>
			<slot name="action"></slot>
		</div>
		<div class="base_card__body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaseCard',
		props: {
			headerBorder: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: '--'
			},
			titleIcon: {
				type: String,
				default: ''
			},
			titleIconWidth: {
				type: String,
				default: '20'
			},
			type: {
				type: String,
				default: 'default'
			},
	    customClass: String
		},
		computed: {
			getTitleIcon () {
				return this.titleIcon ? require(`../../../assets/icon/${ this.titleIcon }`) : null
			}
		}
	};
</script>

<style scoped lang="less">
	.base_card {
		box-sizing: border-box;
		padding: 28px;
		border-radius: 16px;
		background-color: #fff;
		&__header {
			padding-bottom: 28px;
			min-height: 50px;
			font-family: PingFangSC-Medium;
			font-size: 32px;
			font-weight: normal;
			line-height: 41px;
			color: #000;
			&_title {
				display: flex;
				align-items: center;
			}
		}
		&.base_card__primary {
			background-color: @primary;
			.card_header { color: #fff; }
		}
		&.base_card__small {
			.card_header {
				font-size: 30px;
			}
		}
	}
</style>
